export const LEADER_BOARD_TOP_USERS_COUNT = 3;

export const LEADER_BOARD_TITLES = {
    THIS_DAY_LEADER_BOARD: gettext('Daily Leaderboard'),
    THIS_WEEK_LEADER_BOARD: gettext('Weekly Leaderboard'),
    THIS_MONTH_LEADER_BOARD: gettext('Monthly Leaderboard'),
    THIS_QUARTER_LEADER_BOARD: gettext('Quarterly Leaderboard'),
};
